export default __webpack_public_path__ + "resources/icons/n200-ab31.png";